import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from 'common/auth'

const Login = () => import('../views/login/Login')
const ForgotPassword = () => import('../views/forgotPassword/ForgotPassword')
const Home = () => import('../views/home/Home')
const Dashboard = () => import('../views/dashboard/Dashboard')
const User = () => import('../views/user/User')
const Vehicle = () => import('../views/vehicle/Vehicle')
const Trailer = () => import('../views/trailer/Trailer')
const Bind = () => import('../views/bind/Bind')
const BindTrailer = () => import('../views/bind/Trailer')
const Detail = () => import('../views/detail/Detail')
const DetailTrailer = () => import('../views/detail/DetailTrailer')
const Map = () => import('../views/map/Map')
const Setting = () => import('../views/setting/Setting')
const Gateway = () => import('../views/gateway/Gateway')
const Sensor = () => import('../views/sensor/Sensor')
const Alert = () => import('../views/alert/Alert')

// 1. install vue-router
Vue.use(VueRouter)

// 2. create router
const routes = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/forgot_password',
    component: ForgotPassword
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    children: [
      {
        path: '/',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        component: Dashboard
      },
      {
        path: 'user',
        component: User
      },
      {
        path: 'vehicle',
        component: Vehicle
      },
      {
        path: 'trailer',
        component: Trailer
      },
      {
        path: 'bind',
        component: Bind
      },
      {
        path: 'bind_trailer',
        component: BindTrailer
      },
      {
        path: 'detail',
        component: Detail
      },
      {
        path: 'detail_trailer',
        component: DetailTrailer
      },
      {
        path: 'map',
        component: Map
      },
      {
        path: 'setting',
        component: Setting
      },
      {
        path: 'gateway',
        component: Gateway
      },
      {
        path: 'sensor',
        component: Sensor
      },
      {
        path: 'alert',
        component: Alert
      }
    ]
  }
]
const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  const token = getToken() 
	const isLogged = token && token.length === 228 ? true : false
	
  if(to.path === "/login" || to.path === '/forgot_password') {
    next()
  } else if (isLogged) {
    next()
  } else {
    // redirect to login
    next("/login")
  }
  
})

export default router